export default {
  name: 'wisk-stockroom',
  width: 35,
  height: 35,
  paths: [
    {
      d: 'M1,1 h3 v33 h-3Z M31,1 h3 v33 h-3Z M1,4.5 h33 v2.5 h-33Z M1,17.5 h33 v2.5 h-33Z M1,30.5 h33 v2.5 h-33Z M5,8 h7 v9.5 h-7Z M13.5,10 h7 v7.5 h-7Z M5,21 h8 v9.5 h-8Z M14.5,21 h8 v9.5 h-8Z M23.5,24 h6.5 v6.5 h-6.5Z'
    }
  ]
}
